import { Injectable } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'

import { DialogService } from '@tv3/services/utils/dialog.service'
import { AccountRatesDialogComponent, AccountRatesDialogInput } from './account-rates-dialog.component'

@Injectable()
export class AccountRatesDialogService {
  constructor(private dialogService: DialogService) {}

  public openSide(data: AccountRatesDialogInput = {}): MatDialogRef<AccountRatesDialogComponent, void> {
    return this.dialogService.openLargeSide(AccountRatesDialogComponent, {
      panelClass: ['modal', 'side-modal-lg', 'modal-owner-details', 'right'],
      data: data,
    })
  }
}
